module.exports = __webpack_public_path__ + "static/img/login_main.545e594f.png";